import { ReactElement, ReactNode } from "react";
import Title from './title';

type SubtitleProps = {
  as?: string,
  children?: ReactNode
} & ReactElement['props'] & React.HTMLAttributes<HTMLElement>;

export default function Subtitle({ as = 'h5', className = '', children = [], ...props }: SubtitleProps): ReactElement {
  return <Title as={as} className={ `font-normal  ${className}` } {...props}>{ children }</Title>;
}
